import React from "react";
import { Link } from "react-router-dom";
import YTLect from "./YTLect";

const CourseDetailCard = ({
  courseDetails: {
    title,
    subHeading,
    description,
    lesson,
    rating,
    students,
    duration,
    category,
    level,
    isOffered,
    isFeatured,
    courseCode,
    imgUrl,
    instructor,
    enrollNow,
    modules,
  },
}) => {
  return (
    <section className="courseDetail" id="courseDetail">
      <article className="courseDetail__header">
        <div className="courseDetail__header__left">
          <h1>{title}</h1>
          <h2>{subHeading}</h2>
          <h3>Instructor: {instructor}</h3>
          <h4>This Course is a part of {category}.</h4>
          <h5>Course Code: {courseCode}</h5>
          <p className="enroll d-flex align-items-center gap-1">
            <Link
              to={enrollNow}
              target="_parent"
              className={isOffered ? "btn" : "btn .disabled-link"}
            >
              {isOffered ? "Enroll Now" : "Coming Soon"}
            </Link>
          </p>
        </div>
        <div className="courseDetail__header__right">
          <div>
            <h3>Course</h3>
            <p>Gain insight into a topic and learn the fundamentals</p>
            <hr />
            <div>{rating} (26 reviews) | 92%</div>

            <div>
              <h3>{level} level</h3>
              <p>No previous experience necessary</p>
            </div>
            <div>
              <h4>{duration} hours (approximately)</h4>
            </div>

            <div>
              <h4>Flexible schedule</h4>
              <p>Lectures will also be provided online.</p>
            </div>
            <div>
              <h4>Prepare yourself</h4>
            </div>
            <hr />
            <div>
              <p>
                <Link>View course modules</Link>
              </p>
            </div>
          </div>
        </div>
      </article>
      <article>
        <div className="course__top__left w-60">
          <h2>There are {modules && modules.length} modules in this course</h2>
          <p>{description}</p>

          <div className="accordion accordion-flush">
            {modules &&
              modules.map((v, i) => {
                return (
                  <div className="accordion-item" key={v.name}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#flush-collapse${i}`}
                        aria-expanded="false"
                        aria-controls={`flush-collapse${i}`}
                      >
                        <h3>Module {v.id}</h3>
                      </button>
                    </h2>
                    <div
                      id={`flush-collapse${i}`}
                      className="accordion-collapse collapse"
                      data-bs-parent={`#flush-collapse${i}`}
                    >
                      <div className="accordion-body">
                        <h4>{v.name}</h4>
                        <p>{v.description}</p>
                        <YTLect lectures={v.lectures} />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </article>
      <article className="course_detail_card">
        <div className="course_detail_card__img w-full">
          <img
            loading="lazy"
            width={100}
            height={100}
            src={`/${imgUrl}`}
            title={title}
            alt={title}
            className="w-full"
          />
        </div>
      </article>
    </section>
  );
};

export default CourseDetailCard;
